import { routes } from "../General";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { CardBody, CardTitle, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { TourStart } from "../../tour/TourStart";
import { useParams } from "react-router-dom";
import { Form } from "formik";
import { BlkField } from "../../coms/BlkField";
import BlkFormik from "../../coms/BlkFormik";
import { ArchivoPreview } from "../../coms/archivos/ArchivoPreview";
import { ArchivoUpload } from "../../coms/archivos/ArchivoUpload";
import Alerts from "../../util/Alerts";
import { formularioCredito, formularioVam } from "./validacion";
import { JedaiCantidades } from "../../coms/JedaiCantidades";
import { FormikSave } from "../../coms/FormikSave";
import { efiZohoFields } from "../../vam/zoho/FormularioZohoVam";
import elPro from "../../assets/img/elpro.svg";
import { ModalEspere } from "./ModalEspere";
import JedaiTooltip from "../../coms/JedaiTooltip";
import Humanize from "humanize-plus";
import { MAX_TOTAL_SIZE_FILES } from "../../coms/archivos/util";

export const FormularioZoho = props => {
    const alert = React.useRef();
    const signaturePadRef = React.createRef();
    const [list, setList] = useState([]);
    const [item, setItem] = useState({});
    const [titulares, setTitulares] = useState([]);
    const [titular, setTitular] = useState({});
    const [titularData, setTitularData] = useState({});
    const [pacientes, setPacientes] = useState([]);
    const [paciente, setPaciente] = useState({});
    const [formulario, setFormulario] = useState(efiZohoFields());
    const user = useSelector(state => state.user);
    let { id } = useParams();
    const [cdCliente, setCdCliente] = useState(0);
    const [modulo, setModulo] = useState({ moduloDoc: false });
    const [totalSizeFiles, setTotalSizeFiles] = useState(0); // para verificar que totos los archivos no pasen los MB permitidos

    useEffect(() => {
        let tmp = id ? id : props.siniestro ? props.siniestro.cdCliente : user.cdCliente;
        setCdCliente(tmp);
        getAseguradora(tmp);
        setFormulario({
            credito: false,
            subject: null,
            cedulaC: null,
            nombreT: null,
            cedulaT: null,
            paciente: null,
            aseguradora: null,
            emailT: null,
            celularT: null,
            plan: null,
            files: [],
            diagnostico: null,
            celularC: null,
            centroMedico: null,
            escanea: user.usuario,
            valorPresupuestado: null,
            ...efiZohoFields(),
        });
    }, [id, props.isOpen]);

    const getAseguradora = cdCliente => {
        let hospitalario = props?.hospitalario ? props?.hospitalario : false;
        axios
            .get(routes.api + "/siniestro/aseguradora", {
                params: {
                    cdCompania: 1,
                    cdCliente: cdCliente, //pasar en el componente el siniestro
                    caducada: true,
                    hospitalario: hospitalario,
                },
            })
            .then(resp => {
                setList(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    const getTitulares = idUbi => {
        idUbi &&
            axios
                .get(routes.api + "/siniestro/loadtitulares", {
                    params: {
                        cdCompania: 1,
                        cdUbicacion: idUbi,
                    },
                })
                .then(resp => {
                    setTitulares(resp.data);
                })
                .catch(error => {
                    alert.current.handle_error(error);
                });
    };

    const getPaciente = (idCoti, ced) => {
        axios
            .get(routes.api + "/siniestro/cargaAsegurados", {
                params: {
                    cdCompania: 1,
                    cdCotizacion: idCoti,
                    cedula: ced,
                },
            })
            .then(resp => {
                setPacientes(resp.data.asegurados);
                if (resp.data.titular && resp.data.titular.length) {
                    setTitularData(resp.data.titular[0]);
                }
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    const buildUrl = (paciente, values, a3) => {
        let cltx = item.NM_CLIENTE;
        if (item.AP_CLIENTE) {
            cltx = item.AP_CLIENTE + " " + item.NM_CLIENTE;
        }

        let tmp = { ...values, a3 };
        tmp.credito = props.zoho2;
        tmp.subject = cltx;
        tmp.cedulaC = item.RUC_CED;
        tmp.nombreT = titular.dscObjeto;
        tmp.cedulaT = titular.cedulaO;
        tmp.paciente = paciente.NOMBRES;
        tmp.aseguradora = item.NM_ASEGURADORA;
        tmp.emailT = titularData.CORREO;
        tmp.celularT = titularData.CELULAR;
        tmp.plan = item.DSC_PLAN;
        tmp.cdCliente = cdCliente;
        tmp.files = undefined;
        tmp.firma = undefined;
        tmp.poliza = item?.POLIZA || "";
        if (paciente.FC_NACIMIENTO) {
            let part = paciente.FC_NACIMIENTO.split("T")[0];
            let part2 = part.split("-");
            tmp.fechaNacimiento = part2[0] + "-" + part2[1] + "-" + part2[2];
        }
        setFormulario(tmp);
    };

    const onSubmit = (newValues, actions) => {
        let formData = new FormData();
        if (newValues.files && newValues.files.length > 0) {
            newValues.files?.forEach(file => {
                formData.append("files", file, file.name);
            });
            newValues.files = undefined;
        } else {
            alert.current.show_error("Debe al menos subir un archivo");
            actions.setSubmitting(false);
            return;
        }
        newValues.siniestro = props.siniestro; // pa saber q siniestro pertenece siesq existe
        formData.append("item", new Blob([JSON.stringify(newValues)], { type: "application/json" }));
        axios
            .post(routes.apiVam + "/ticket/crear", formData, {
                headers: {
                    "content-Type": "multipart/form-data",
                },
            })
            .then(resp => {
                showConfirmacion(true);
                actions.setSubmitting(false);
            })
            .catch(error => {
                alert.current.show_error(
                    `El ticket no se ha creado correctamente. ${error.response?.data?.errors[0]?.errorMessage ?? "Contáctese con soporte"}`
                );
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    const handleClear = setFieldValue => {
        const signaturePad = signaturePadRef.current;
        if (signaturePad) {
            signaturePad.instance.clear();
            setFieldValue("firma", null);
        }
    };

    const showConfirmacion = open => {
        setModulo({ moduloDoc: open });
    };

    const handleTotalSize = (size, operator = "+") => {
        if (operator == "+") {
            setTotalSizeFiles(totalSizeFiles + size);
        } else {
            setTotalSizeFiles(totalSizeFiles - size);
        }
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <div className="card bg-primary">
                <CardBody>
                    {props.zoho2 === true ? (
                        <CardTitle tag="h4" className={"text-white"}>
                            Documento Crédito Hospitalario/Ambulatorio
                        </CardTitle>
                    ) : (
                        <CardTitle tag="h4" className={"text-white"}>
                            Documento Asistencia Médica
                        </CardTitle>
                    )}
                    <div className={"d-block text-center text-primary"}>
                        <TourStart type={"documentos"} auto={false} />
                    </div>
                    <BlkFormik
                        initialValues={formulario}
                        onSubmit={onSubmit}
                        enableReinitialize={true}
                        validateOnChange={false}
                        validationSchema={props.zoho2 ? formularioCredito : formularioVam}
                    >
                        {({ values, isSubmitting, setFieldValue, submitForm }) => (
                            <Form>
                                <div>
                                    <div className="row">
                                        <div className="form-group col-lg-6" id={"combo_aseg"}>
                                            <Label>Aseguradora / Plan</Label>
                                            <BlkField
                                                component={"select"}
                                                className="form-control"
                                                onChange={e => {
                                                    const { value } = e.target;
                                                    let item = list.find(
                                                        a => a.CD_COTIZACION + "_" + a.CD_UBICACION === value
                                                    );
                                                    getTitulares(item?.CD_UBICACION);
                                                    setItem(item);
                                                    setTitular({});
                                                    setTitulares([]);
                                                    setPaciente({});
                                                    setPacientes([]);
                                                    setFieldValue("a1", value);
                                                    setFieldValue("a2", "");
                                                    setFieldValue("a3", "");
                                                }}
                                                name={"a1"}
                                            >
                                                <option value={0}>--Seleccione--</option>
                                                {list.map(a => (
                                                    <option
                                                        value={a.CD_COTIZACION + "_" + a.CD_UBICACION}
                                                        key={a.CD_COTIZACION + "_" + a.CD_UBICACION}
                                                    >
                                                        {a.ASEGURADORA}/{a.DSC_UBICACION}/{a.DSC_PLAN}
                                                    </option>
                                                ))}
                                            </BlkField>
                                        </div>

                                        <div className="form-group col-lg-6" id={"combo_titular"}>
                                            <Label>Titular </Label>
                                            <BlkField
                                                component={"select"}
                                                className="form-control"
                                                value={titular.cedulaO}
                                                onChange={e => {
                                                    setTitular(titulares.find(a => a.cedulaO === e.target.value));
                                                    getPaciente(item.CD_COTIZACION, e.target.value);
                                                    setFieldValue("a2", e.target.value);
                                                }}
                                                name={"a2"}
                                            >
                                                <option value={0}>--Seleccione--</option>
                                                {titulares.map(a => (
                                                    <option value={a.cedulaO} key={a.cedulaO}>
                                                        {a.dscObjeto}
                                                    </option>
                                                ))}
                                            </BlkField>
                                        </div>

                                        <div className="form-group col-lg-6" id={"combo_paciente"}>
                                            <Label>Paciente</Label>
                                            <BlkField
                                                component={"select"}
                                                className="form-control"
                                                value={paciente.CD_ASEGURADO}
                                                onChange={e => {
                                                    let pacien = pacientes.find(
                                                        a => a.CD_ASEGURADO === parseInt(e.target.value)
                                                    );
                                                    setPaciente(pacien);
                                                    buildUrl(pacien, values, e.target.value);
                                                }}
                                                name={"a3"}
                                            >
                                                <option value={0}>--Seleccione--</option>
                                                {pacientes.map(a => (
                                                    <option value={a.CD_ASEGURADO} key={a.CD_ASEGURADO}>
                                                        {a.NOMBRES}
                                                    </option>
                                                ))}
                                            </BlkField>
                                        </div>

                                        {props.zoho2 === true ? (
                                            <>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Plan Contratado:</Label>
                                                    <BlkField className="form-control" type="text" name="plan" />
                                                </div>
                                                <div className="col">
                                                    <div className={"form-group col-md-6 col-sm-12"}>
                                                        <Label>Diagnóstico:</Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            name={"diagnostico"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Celular Contacto:</Label>
                                                    <BlkField className="form-control" type="text" name={"celularT"} />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Centro Médico:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        name="centroMedico"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Médico tratante:</Label>
                                                    <BlkField className="form-control" type="text" name="medico" />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Valor Presupuestado:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        component={JedaiCantidades}
                                                        step={0.01}
                                                        name="valorPresupuestado"
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <Label>
                                                            Observaciones o Instrucciones especiales para cada crédito:
                                                        </Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            component="textarea"
                                                            placeholder="Observaciones"
                                                            name="observacionesHp"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Diagnóstico:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        name={"diagnostico"}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Celular Contacto:</Label>
                                                    <BlkField className="form-control" type="text" name={"celularT"} />
                                                </div>
                                                <div className="form-group col-md-6 col-sm-12">
                                                    <Label>Observaciones o instrucciones especiales:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        component="textarea"
                                                        placeholder="Observaciones"
                                                        name={"observaciones"}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col">
                                            <Label>Carga de archivos:</Label>
                                            <div className="files">
                                                <ArchivoPreview values={values} edit={isSubmitting} />
                                                {!isSubmitting && (
                                                    <ArchivoUpload
                                                        id={"archivo"}
                                                        values={values}
                                                        maxFileSize={"18MB"}
                                                        setFieldValue={setFieldValue}
                                                        handleTotalSize={handleTotalSize}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FormikSave
                                                type="button"
                                                className="btn btn-secondary my-2"
                                                disabled={isSubmitting || totalSizeFiles > MAX_TOTAL_SIZE_FILES}
                                                onClick={submitForm}
                                            />
                                            <span>
                                                &nbsp;
                                                <JedaiTooltip
                                                    message={`El peso total permitido es (${Humanize.fileSize(MAX_TOTAL_SIZE_FILES)})`}
                                                >
                                                    <i className={"fa fa-info-circle text-white"} />
                                                </JedaiTooltip>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className={"modal-espere"}>
                                    <ModalEspere open={isSubmitting} />
                                </div>
                            </Form>
                        )}
                    </BlkFormik>
                </CardBody>
            </div>
            <Confirmacion open={modulo.moduloDoc} toggleModal={showConfirmacion} onClose={props.onClose} />
        </div>
    );
};

export function base64toBlob(base64Data, contentType) {
    contentType = contentType || "";
    let sliceSize = 1024;
    let byteCharacters = atob(base64Data);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new File(byteArrays, "firma.png", { type: contentType, name: "firma.pnf" });
}

export const handleSave = (setFieldValue, alert, signaturePadRef) => {
    const signaturePad = signaturePadRef.current;
    if (!signaturePad) {
        return;
    }
    if (signaturePad.isEmpty()) {
        // eslint-disable-next-line no-alert
        alert.current.show_info("Por favor ingrese una firma");
    } else {
        const url = signaturePad.toDataURL();
        const tmp = url.split(";base64,");
        const firma = base64toBlob(tmp[1], "image/png");
        setFieldValue("firma", firma);
        alert.current.show_info("Su firma ha sido guardada");
    }
};

export const Confirmacion = ({ open, toggleModal, onClose }) => {
    const closeModal = () => {
        toggleModal(false);
    };

    return (
        <div className="content">
            <Modal className="text-center modal-lg" isOpen={open}>
                <ModalHeader className="justify-content-center title" tag="h4">
                    Confirmación de Ticket
                    <button
                        type="button"
                        className="close"
                        title="Cerrar"
                        onClick={() => {
                            onClose();
                            closeModal();
                        }}
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="pt-0 mt-0">
                    <div className="container">
                        <Row className="justify-content-center">
                            <div className={"col-md-2 d-flex justify-content-center align-items-center"}>
                                <img src={elPro} alt="..." className={"asistente-big asistente-zoho-form m-3"} />
                            </div>

                            <div className="col-md-6">
                                <div className={"p-3 text-left"}>
                                    <span className="text_align-center">
                                        ¡Muchas gracias, tu siniestro se ha creado correctamente!
                                    </span>
                                    <br />
                                    <span className="text_align-center">
                                        Por favor estar atento a tu email ya que ahí recibirás comunicaciones
                                        importantes en relación al mismo.
                                    </span>
                                </div>
                            </div>
                        </Row>
                    </div>
                    <br />
                    <br />
                </ModalBody>
            </Modal>
        </div>
    );
};
